"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  Kindle1: ['kindle-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M19.5,0H4.5A1.5,1.5,0,0,0,3,1.5v21A1.5,1.5,0,0,0,4.5,24h15A1.5,1.5,0,0,0,21,22.5V1.5A1.5,1.5,0,0,0,19.5,0ZM6,20a1,1,0,0,1-1-1V3A1,1,0,0,1,6,2H18a1,1,0,0,1,1,1V19a1,1,0,0,1-1,1Z', 'M8.5,6.251h7a.75.75,0,0,0,0-1.5h-7a.75.75,0,0,0,0,1.5Z', 'M8.5,9.751h7a.75.75,0,0,0,0-1.5h-7a.75.75,0,0,0,0,1.5Z', 'M8.5,13.251h7a.75.75,0,0,0,0-1.5h-7a.75.75,0,0,0,0,1.5Z', 'M8.5,16.751H14a.75.75,0,1,0,0-1.5H8.5a.75.75,0,1,0,0,1.5Z']],
  Kindle: ['kindle', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M21.75,15h-3a.249.249,0,0,0-.25.25V16.5a1,1,0,0,1-1,1H6.5a1,1,0,0,1-1-1v-1.25A.249.249,0,0,0,5.25,15h-3a.249.249,0,0,0-.25.25V21.5A2.5,2.5,0,0,0,4.5,24h15A2.5,2.5,0,0,0,22,21.5v-6.25A.249.249,0,0,0,21.75,15ZM14,21a.5.5,0,0,1-.5.5h-3A.5.5,0,0,1,10,21V20a.5.5,0,0,1,.5-.5h3a.5.5,0,0,1,.5.5Z', 'M9,7.251h6a.75.75,0,0,0,0-1.5H9a.75.75,0,0,0,0,1.5Z', 'M9,10.251h6a.75.75,0,0,0,0-1.5H9a.75.75,0,0,0,0,1.5Z', 'M9,13.251h4a.75.75,0,0,0,0-1.5H9a.75.75,0,0,0,0,1.5Z', 'M19.5,0H4.5A2.5,2.5,0,0,0,2,2.5v10.75a.25.25,0,0,0,.25.25h3a.25.25,0,0,0,.25-.25V3.5a1,1,0,0,1,1-1h11a1,1,0,0,1,1,1v9.75a.25.25,0,0,0,.25.25h3a.25.25,0,0,0,.25-.25V2.5A2.5,2.5,0,0,0,19.5,0Z']],
  TabletTouch: ['tablet-touch', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M5.92,16.823a.253.253,0,0,0-.041-.219.248.248,0,0,0-.2-.1H5.5a1,1,0,0,1-1-1v-12a1,1,0,0,1,1-1h14a1,1,0,0,1,1,1V14.182a.249.249,0,0,0,.194.244,6.186,6.186,0,0,1,2.884,1.555A.25.25,0,0,0,24,15.8V2.505a2.5,2.5,0,0,0-2.5-2.5H2.5A2.5,2.5,0,0,0,0,2.505v14a2.5,2.5,0,0,0,2.5,2.5H5.652a.251.251,0,0,0,.242-.312A3.6,3.6,0,0,1,5.92,16.823Z', 'M23,24a.75.75,0,0,0,.75-.75v-3A4.756,4.756,0,0,0,19,15.5H17a.25.25,0,0,1-.25-.25v-5.5a2.25,2.25,0,0,0-4.5,0v7.06a.25.25,0,0,1-.442.16l-.578-.7a2.25,2.25,0,0,0-3.46,2.877l3.806,4.579a.751.751,0,0,0,.577.271Z']],
  Tablet1: ['tablet-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M18.5,0H5.5A2.5,2.5,0,0,0,3,2.5v19A2.5,2.5,0,0,0,5.5,24h13A2.5,2.5,0,0,0,21,21.5V2.5A2.5,2.5,0,0,0,18.5,0ZM19,18.5A1.5,1.5,0,0,1,17.5,20H6.5A1.5,1.5,0,0,1,5,18.5V5.5A1.5,1.5,0,0,1,6.5,4h11A1.5,1.5,0,0,1,19,5.5Z']],
  Tablet: ['tablet', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M19,0H5A2.5,2.5,0,0,0,2.5,2.5v19A2.5,2.5,0,0,0,5,24H19a2.5,2.5,0,0,0,2.5-2.5V2.5A2.5,2.5,0,0,0,19,0ZM5,4.5a1,1,0,0,1,1-1H18a1,1,0,0,1,1,1v14a1,1,0,0,1-1,1H6a1,1,0,0,1-1-1Z', 'M6.750 6.251 L9.250 6.251 L9.250 8.751 L6.750 8.751 Z', 'M10.750 6.251 L13.250 6.251 L13.250 8.751 L10.750 8.751 Z', 'M14.750 6.251 L17.250 6.251 L17.250 8.751 L14.750 8.751 Z', 'M6.750 10.251 L9.250 10.251 L9.250 12.751 L6.750 12.751 Z', 'M10.750 10.251 L13.250 10.251 L13.250 12.751 L10.750 12.751 Z', 'M6.750 14.251 L9.250 14.251 L9.250 16.751 L6.750 16.751 Z', 'M10.750 14.251 L13.250 14.251 L13.250 16.751 L10.750 16.751 Z', 'M14.750 10.251 L17.250 10.251 L17.250 12.751 L14.750 12.751 Z']],
  TabletTouch1: ['tablet-touch-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M6.7,20.229a3.812,3.812,0,0,1,1.735-2.363.2.2,0,0,0-.1-.367H5a1,1,0,0,1-1-1V4.5a1,1,0,0,1,1-1H17a1,1,0,0,1,1,1V16.1a.25.25,0,0,0,.25.25H19a5.016,5.016,0,0,1,1.183.163.25.25,0,0,0,.314-.242V2.5A2.5,2.5,0,0,0,18,0H4A2.5,2.5,0,0,0,1.5,2.5v17A2.5,2.5,0,0,0,4,22H6.4a.252.252,0,0,0,.19-.087.255.255,0,0,0,.057-.2A3.792,3.792,0,0,1,6.7,20.229Z', 'M6.250 5.749 L9.750 5.749 L9.750 9.249 L6.250 9.249 Z', 'M12.250 5.749 L15.750 5.749 L15.750 9.249 L12.250 9.249 Z', 'M6.250 11.249 L9.750 11.249 L9.750 14.749 L6.250 14.749 Z', 'M19,17.852H16.75a.25.25,0,0,1-.25-.25V13.1a2.25,2.25,0,0,0-4.5,0v5.87a.251.251,0,0,1-.129.219.249.249,0,0,1-.254-.008,2.289,2.289,0,0,0-3.2,3.088l.668,1.318a.75.75,0,0,0,1.338-.679l-.7-1.376a.79.79,0,0,1,1.287-.912l1.159,1.448A.75.75,0,0,0,13.5,21.6V13.1a.75.75,0,0,1,1.5,0v5.5a.75.75,0,0,0,.75.75h3.238A2.138,2.138,0,0,1,21,21.5v1.75a.75.75,0,0,0,1.5,0V21.5A3.621,3.621,0,0,0,19,17.852Z']],
  KindleHold: ['kindle-hold', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M12.5,12.251h-7a.75.75,0,1,0,0,1.5h7a.75.75,0,0,0,0-1.5Z', 'M12.5,8.751h-7a.75.75,0,0,0,0,1.5h7a.75.75,0,0,0,0-1.5Z', 'M5.5,5.251a.75.75,0,0,0,0,1.5H11a.75.75,0,0,0,0-1.5Z', 'M23.911,22.891,21.78,18.923a.244.244,0,0,1-.03-.118V14.991c0-1.821-1.323-2.815-2.856-3.966-.254-.191-.521-.392-.8-.607a.251.251,0,0,1-.1-.2V1.5A1.5,1.5,0,0,0,16.5,0H1.5A1.5,1.5,0,0,0,0,1.5V20a1.5,1.5,0,0,0,1.5,1.5H15.13a.25.25,0,0,1,.215.122,15.242,15.242,0,0,0,1.594,2.126.75.75,0,0,0,1.121-1A8.389,8.389,0,0,1,16.25,20V19a.75.75,0,0,0-.178-.485l-1.753-2.071a.731.731,0,0,1,1.075-.99l2.576,2.576a.75.75,0,1,0,1.06-1.061l-.957-.957A.251.251,0,0,1,18,15.836V12.731a.25.25,0,0,1,.4-.2c1.246.951,1.848,1.528,1.848,2.458v4.065a.745.745,0,0,0,.089.355l2.25,4.189a.757.757,0,0,0,1.015.306A.749.749,0,0,0,23.911,22.891Zm-10.4-8.68a2.249,2.249,0,0,0-.536,2.909.25.25,0,0,1-.214.381H3a1,1,0,0,1-1-1V3A1,1,0,0,1,3,2H15a1,1,0,0,1,1,1v10.65a.251.251,0,0,1-.338.234A2.23,2.23,0,0,0,13.508,14.211Z']]
};
exports["default"] = _default;